import { useState, useEffect } from 'react';

type Option = { label: string; value: string };

interface CustomSelectProps {
  options: Option[];
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
}

export default function CustomSelect({ options, value, onChange, placeholder }: CustomSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!isDesktop) {
    // Fall back to native <select> on mobile
    return (
      <select
        className="w-full input-base select-base"
        value={value}
        onChange={e => onChange(e.target.value)}
      >
        <option value="">{placeholder || '-- Select --'}</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    );
  }

  const selected = options.find(opt => opt.value === value);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full input-base select-base"
      >
        {selected?.label || placeholder || '-- Select --'}
      </button>

      {isOpen && (
        <ul className="custom-select-dropdown absolute z-50 mt-1 bg-gray-300 bg-opacity-25 backdrop-blur-md w-full rounded-[1rem] shadow-md max-h-60 overflow-auto p-4">
          {options.map(opt => (
            <li
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setIsOpen(false);
              }}
              className={`px-4 py-2 mb-1 cursor-pointer rounded-lg hover:bg-white hover:text-blue-700 ${
                opt.value === value ? 'bg-slate-300' : ''
              }`}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
